import React from "react";
import MainPanel from "./MainPanel";

const Unimplemented = () => <MainPanel title="New Feature: Coming Soon" />;

export default Unimplemented;
